<div class="total-div" [style.background]="data?.background">
  <img src="../../../../assets/icon/big-round.png" alt="" class="big-r" />
  <img src="../../../../assets/icon/small-round.png" alt="" class="small-r" />
  <div class="main-logo">
    <img src="{{ data?.jackpot_image }}" alt="Jackpot Image" class="logo" loading="lazy" />
  </div>
  <div class="amount-sec">
    <p class="amount">{{currencySymbol}}{{data?.jackpot_value}}@if (data?.isReachedThreshold) {
      <span>🔥</span>
    }</p>
    <p [ngClass]="data?.jackpot_name === 'EuroMillions' ? 'lines' : 'lines-white'">
      <span>{{ data?.lines }}</span> {{ jackpotTriggerTranslatedData?.lines_for | translate }}
      <span>{{currencySymbol}}{{ formatCurrencyDisplay(data?.int_price?.[preferredCurrency] ?? data?.price) }}</span>
    </p>
  </div>
  @if (data?.jackpot_name) {
    <p class="for-activate">
      {{ jackpotTriggerTranslatedData?.euro_desc | translate }}
    </p>
  }

  <!-- list wrapper -->
  @if (data?.jackpot_name && !['Lotto', 'Powerball'].includes(data?.jackpot_name)) {
    <div class="list-card">
      <ul>
        <li><mat-icon>check</mat-icon> {{ data?.lines }} {{ jackpotTriggerTranslatedData?.Only | translate }} <strong>
        {{currencySymbol}}{{data?.int_jackpot?.[preferredCurrency] ? data?.int_jackpot?.[preferredCurrency]
      :data?.jackpot}} </strong></li>
      <li><mat-icon>check</mat-icon> {{ jackpotTriggerTranslatedData?.EuroMillions | translate }}</li>
      <li><mat-icon>check</mat-icon> {{ jackpotTriggerTranslatedData?.Get | translate }}
      {{currencySymbol}}{{ formatCurrencyDisplay(data?.int_price?.[preferredCurrency] ?? data?.price) }} {{jackpotTriggerTranslatedData?.per
    | translate}}</li>
    @if (jackpotTriggerObj.alias.includes('-alt') || jackpotTriggerObj.alias.includes('-free')) {
      <li>
        <mat-icon>check</mat-icon>
        {{ jackpotTriggerObj.alias.includes('-alt') ? jackpotTriggerTranslatedData?.alternate_text :
        jackpotTriggerTranslatedData?.free_text }}
      </li>
    }
  </ul>
</div>
}

<!-- list wrapper -->
@if (data?.jackpot_name === 'Lotto') {
  <div class="list-card">
    <ul>
      <li><mat-icon>check</mat-icon> {{ data?.lines }} {{ jackpotTriggerTranslatedData?.Only | translate }} <strong>
      {{currencySymbol}}{{data?.int_jackpot?.[preferredCurrency] ? data?.int_jackpot?.[preferredCurrency]
    :data?.jackpot}} </strong></li>
    <li><mat-icon>check</mat-icon> {{ jackpotTriggerTranslatedData?.Lotto | translate }}</li>
    <li><mat-icon>check</mat-icon> {{ jackpotTriggerTranslatedData?.Get | translate }}
    {{currencySymbol}}{{ formatCurrencyDisplay(data?.int_price?.[preferredCurrency] ?? data?.price) }} {{jackpotTriggerTranslatedData?.per
  | translate}}</li>
  @if (jackpotTriggerObj.alias.includes('-alt') || jackpotTriggerObj.alias.includes('-free')) {
    <li>
      <mat-icon>check</mat-icon>
      {{ jackpotTriggerObj.alias.includes('-alt') ? jackpotTriggerTranslatedData?.alternate_text :
      jackpotTriggerTranslatedData?.free_text }}
    </li>
  }
</ul>
</div>
}

<!-- list wrapper -->
@if (data?.jackpot_name === 'Powerball') {
  <div class="list-card">
    <ul>
      <li><mat-icon>check</mat-icon> {{ data?.lines }} {{ jackpotTriggerTranslatedData?.Only | translate }} <strong>
      {{currencySymbol}}{{data?.int_jackpot?.[preferredCurrency] ? data?.int_jackpot?.[preferredCurrency]
    :data?.jackpot}} </strong></li>
    <li><mat-icon>check</mat-icon> {{ jackpotTriggerTranslatedData?.Powerball | translate }}</li>
    <li><mat-icon>check</mat-icon> {{ jackpotTriggerTranslatedData?.Get | translate }}
    {{currencySymbol}}{{ formatCurrencyDisplay(data?.int_price?.[preferredCurrency] ?? data?.price) }} {{jackpotTriggerTranslatedData?.per
  | translate}}</li>
  @if (jackpotTriggerObj.alias.includes('-alt') || jackpotTriggerObj.alias.includes('-free')) {
    <li>
      <mat-icon>check</mat-icon>
      {{ jackpotTriggerObj.alias.includes('-alt') ? jackpotTriggerTranslatedData?.alternate_text :
      jackpotTriggerTranslatedData?.free_text }}
    </li>
  }
</ul>
</div>
}

<button (click)="openPaymentPage()" [disabled]="isJptActived()" class="act-btn">
  {{ jackpotTriggerTranslatedData?.Activate | translate }}
</button>
</div>
